import {ChangeDetectionStrategy, Component, EventEmitter, Output,} from '@angular/core';

const MAKS_KOLONNER = 15;
const MAKS_RADER = 15;
const MIN_DISTANSE_PX = 70;

@Component({
    selector: 'riktekst-redigering-tabellstoerrelse-velger',
    templateUrl: 'tabellstørrelse-velger.html',
    styleUrl: 'tabellstørrelse-velger.scss',
    imports: [],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiktekstRedigeringTabellstørrelseVelgerKomponent {

    protected tableSize = {
        rows: 1,
        cols: 1,
    };

    @Output()
    public readonly vedStoerrelseValgt = new EventEmitter<{ cols: number; rows: number }>();

    protected get antallKolonner(): number[] {
        return new Array(Math.min(Math.max(3, this.tableSize.cols + 1), MAKS_KOLONNER)).fill(null).map((_, indeks) => indeks + 1);
    }

    protected get antallRader(): number[] {
        return new Array(Math.min(Math.max(3, this.tableSize.rows + 1), MAKS_RADER)).fill(null).map((_, indeks) => indeks + 1);
    }

    protected erCelleMarkert(rad: number, kol: number): boolean {
        return rad <= this.tableSize.rows && kol <= this.tableSize.cols;
    }

    protected oppdaterStoerrelse(rad: number, kol: number, event: MouseEvent): void {
        if (this.viewportBredde() - event.clientX > MIN_DISTANSE_PX) {
            this.tableSize = {rows: rad, cols: kol};
        }
    }

    private viewportBredde(): number {
        return Math.max(window.document.documentElement.clientWidth || 0, window.innerWidth || 0);
    }

    protected velg(): void {
        this.vedStoerrelseValgt.emit(this.tableSize);
    }
}

